export function Badge({ color = 'default', children }) {
  return <span className={`badge ${color}`}>{children}</span>;
}
